<div class="company-form" [class.cf-native]="nativeInput">
  <div class="form-row">
    <!-- Bare native input: the host owns the label and styling (e.g. the due
         diligence page). Autocomplete attaches directly to the input. -->
    <input
      *ngIf="nativeInput"
      class="cf-native-input"
      type="text"
      [formControl]="legalNameControl"
      [matAutocomplete]="autoCompanySearch"
      [placeholder]="legalNamePlaceholder"
      (input)="onLegalNameInput()"
    />

    <!-- Default Material outline field. -->
    <mat-form-field
      *ngIf="!nativeInput"
      appearance="outline"
      class="full-width"
    >
      <mat-label>Legal Name</mat-label>
      <input
        matInput
        type="text"
        [formControl]="legalNameControl"
        [matAutocomplete]="autoCompanySearch"
        [placeholder]="legalNamePlaceholder"
        (input)="onLegalNameInput()"
        required
      />
    </mat-form-field>

    <mat-autocomplete
      #autoCompanySearch="matAutocomplete"
      [displayWith]="displayCompanySearch"
      (optionSelected)="onCompanySearchSelect($event.option.value)"
      [class]="companySearchPanelClass"
    >
      <!-- Leads the list and stays there: reachable however long the results
           run. It used to be pinned to the foot, floating over the last row. -->
      <mat-option
        *ngIf="hasFreeTextAction"
        [value]="{ _freeText: legalNameText }"
        class="free-text-option"
      >
        <span class="free-text-label">
          <mat-icon>edit</mat-icon>
          Set “<strong>{{ legalNameText }}</strong
          >” as a new company
        </span>
        <span class="free-text-hint"
          >not in the index yet — we'll research it before building the
          query</span
        >
      </mat-option>

      <!-- Company results -->
      <ng-container *ngIf="companySearchResults$ | async as results">
        <mat-optgroup *ngIf="results.length">
          <div class="search-header">
            <span class="header-name">Company</span>
            <span class="header-country">Country</span>
            <span class="header-count"># Articles</span>
          </div>
          <mat-option *ngFor="let hit of results" [value]="hit">
            <div class="search-result-row">
              <span class="result-name">{{ hit.entity.name }}</span>
              <span class="result-country">{{
                hit.entity.country?.alpha_id | uppercase
              }}</span>
              <span class="result-count">{{ hit.count ?? '-' }}</span>
            </div>
          </mat-option>
        </mat-optgroup>
      </ng-container>
    </mat-autocomplete>
  </div>

  <div class="form-row" *ngIf="isNewCompany">
    <!-- Website -->
    <div class="cf-field" *ngIf="nativeInput">
      <label class="cf-label">Website</label>
      <input
        class="cf-native-input"
        type="url"
        [(ngModel)]="website"
        (ngModelChange)="emitSearchState()"
        [readonly]="enriching"
        placeholder="https://…"
      />
    </div>
    <mat-form-field *ngIf="!nativeInput" appearance="outline">
      <mat-label>Website</mat-label>
      <input
        matInput
        type="url"
        [(ngModel)]="website"
        (ngModelChange)="emitSearchState()"
        [readonly]="enriching"
        required
      />
    </mat-form-field>

    <!-- Country -->
    <div class="cf-field" *ngIf="nativeInput">
      <label class="cf-label">Country</label>
      <input
        class="cf-native-input"
        type="text"
        [formControl]="countryControl"
        [matAutocomplete]="autoCountry"
        placeholder="Search country"
      />
    </div>
    <mat-form-field *ngIf="!nativeInput" appearance="outline">
      <mat-label>Country</mat-label>
      <input
        matInput
        type="text"
        [formControl]="countryControl"
        [matAutocomplete]="autoCountry"
        required
      />
    </mat-form-field>

    <mat-autocomplete
      #autoCountry="matAutocomplete"
      [displayWith]="displayGroupingEntity"
      (optionSelected)="emitSearchState()"
      [class]="countryPanelClass"
    >
      <mat-option
        *ngFor="let country of filteredCountries | async"
        [value]="country"
      >
        {{ country.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
</div>
